function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg width="40" height="40" viewBox="0 0 20 20" {...props}><path d="M10 2a8 8 0 1 1 0 16 8 8 0 0 1 0-16zm0 1a7 7 0 1 0 0 14 7 7 0 0 0 0-14zm2.47 3.47l1.06 1.06L11.06 10l2.47 2.47-1.06 1.06L10 11.062l-2.47 2.47-1.06-1.06L8.939 10l-2.47-2.47L7.53 6.47 10 8.939l2.47-2.47z" /></svg>;
});